import React from "react";
import { followUs } from "../AboutUsPage/constants";
import { allFooterLinks } from "../../components/Footer/links";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './defaultStyle.css'
const footerLinks = [
  {
    id: 1,
    icon: faYoutube,
    url: "https://www.youtube.com/channel/UCxX6KabxbGpk9Be57xMktRQ",
  },
  {
    id: 2,
    icon: faFacebook,
    url: "https://www.facebook.com/CareerNinjaIndia/",
  },
  {
    id: 3,
    icon: faInstagram,
    url: "https://www.instagram.com/learntube.ai/?hl=en",
  },
  {
    id: 4,
    icon: faLinkedin,
    url: "https://www.linkedin.com/company/careerninja/mycompany/",
  },
];
const CertificateVerificationFooter = () => {
  return (
    <div
      className="w-full flex flex-col items-center justify-center bg-[#1B3F63] py-6 footer-shadow"
    >
      <div className="w-[60%] md:w-[18%] flex justify-between items-center ">
        {
          footerLinks?.map((item, index)=>  <a
          target="_blank"
          rel="noreferrer"
          href={item?.url}
          className="text-white flex items-center justify-center rounded-full w-[44px] h-[44px] md:w-[54px] md:h-[54px] bg-[#235B93]"
        >
          <FontAwesomeIcon
            size="xl"
            icon={item?.icon}
          />
        </a> )}
       
      
      </div>
      <div className="flex justify-between w-[65%] md:w-[22%] text-white mt-6 items-center font-medium text-[16px] md:text-[20px]">
        <div className='cursor-pointer' onClick={(e)=> window.open('https://learntube.ai','_blank')}>Home</div>
        <div className='cursor-pointer' onClick={(e)=> window.open('https://learntube.ai/about-us','_blank')}>About Us</div>
        <div className='cursor-pointer' onClick={(e)=> window.open('https://learntube.ai/contactus','_blank')}>Contact Us</div>
      </div>
      <div className="text-[14px] md:text-[18px] mt-6 semi-transparent-text " >
              © 2023 CareerNinja
      </div>
    </div>
  );
};

export default CertificateVerificationFooter;
